import waitingDogsJpg from './dog-waiting-for-food.jpg';
import waitingDogsWebP from './dog-waiting-for-food.webp';

export const waitingDogs = [waitingDogsWebP, waitingDogsJpg];
